<template>
  <router-view></router-view>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
export default {
  name: 'app',
  methods: {
    validateSession() {
      axios.get('vendor/v1/auth/session/auth/check').then(response => {
        // console.log('RESPONSE VALIDATE: ', response.data.data)
        const status = response.data.data.status
        if (status == 'UNAUTHORIZED') {
          // get session
          const count = localStorage.getItem('paradigm_session_count')
          if (count) {
            if (count >= 3) {
                localStorage.removeItem('paradigm_session_count')
                this.$toast.success("Session expired! Please login.", "Error", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });

                // Auth.Session.delete()
                // localStorage.removeItem('paradigm_session_count')
                // window.location.href = '/login'
            } else {
              localStorage.setItem('paradigm_session_count', parseInt(count) + 1)
            }
          } else {
            localStorage.setItem('paradigm_session_count', 1)
          }
        }
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  watch: {
    $route(to, from) {
      // console.log
      // skip for login /login
      console.log('from', from.params.id)
      if (to.name !== 'Login') {
        this.validateSession()
      }
    }
  }
}
</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Flag Icons Set */
@import '~flag-icon-css/css/flag-icon.min.css';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import 'assets/scss/style';
</style>
